import React from 'react'
import { Select } from 'antd'
import { WalletOutlined } from '@ant-design/icons'
import { IFuelBalance, IRefuelWallet } from './types'
import Leftovers from './Leftovers'

const { Option } = Select

export interface IFWalletField {
  wallets: IRefuelWallet[]
  wallet?: string
  onWallet: (id: string) => void
  /** Litres of each fuel on the chosen wallet; `undefined` when the load failed. */
  balance?: IFuelBalance[]
  loading: boolean
  /** Why the leftovers could not be fetched, when they could not. */
  error?: string
}

/** The hint under the picker while there are no leftovers to show. */
const hintText = ({ wallet, loading, balance, error }: IFWalletField) => {
  if (!wallet) return 'Оберіть рахунок, з якого спишеться пальне'
  if (loading) return 'Завантаження залишків…'
  if (error) return error
  if (!balance) return 'Залишки недоступні'
  return 'Немає залишків пального на цьому рахунку'
}

/**
 * The wallet picker of the page for app users, with the wallet's own balance
 * under it. The cabinet picks its wallet in the header, so the modal never
 * renders this.
 */
const WalletField: React.FC<IFWalletField> = (props) => (
  <div className="refuel-field">
    <label>Рахунок</label>
    <Select
      placeholder="Оберіть рахунок"
      value={props.wallet}
      onChange={props.onWallet}
      getPopupContainer={(node) => node.parentNode as HTMLElement}
      showSearch
      optionLabelProp="label"
      optionFilterProp="label"
    >
      {props.wallets.map((item) => (
        <Option
          key={item.id}
          value={item.id}
          label={item.name}
          className="refuel-account-option"
        >
          <span className="refuel-account-option__name">{item.name}</span>
          {!!item.organization && (
            <span className="refuel-account-option__balance">
              {item.organization}
            </span>
          )}
        </Option>
      ))}
    </Select>
    <Leftovers
      fuels={props.wallet && !props.loading && props.balance ? props.balance : []}
      label="Залишок на рахунку"
      icon={<WalletOutlined />}
      empty={hintText(props)}
    />
  </div>
)

export default WalletField
